<template>
    <div id="EditProducerData">
      <EditProducer :data="is_admin_dealer" />
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import EditProducer from "../producer/EditProducer.vue"
  
  
  export default {
    name: "EditProducerData",
    created() {
      
    },
    data() {
      return {
        is_admin_dealer:1
      };
    },
    components: {
      EditProducer
    },
   
    methods: {
     
    },
   
  };
  </script>
  
  <style scoped>
  
  </style>